//
// DataItem.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataItemBase";
import "@sas-dvr/ltjs-commons/models/data/dataset/DataUsage";
import "@sas-dvr/ltjs-commons/models/data/dataset/StatisticType";
import "./DataItemVisibility";
import "@sas-dvr/ltjs-commons/models/data/sorting/SortPreprocessing";
import "../results/sorting/CustomSort";
import "../dataSource/TimeFrame";
import "../dataSource/GeoInfo";
import "./Partition";
import "./PartitionOriginType";

var DataItem = createModule("BIRD::DataItem", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::DataItemOrPromptDefinition","BIRD::DataItemBase"], EventDispatcher, [
    ,
    {
        partitions: [1],
        xref: 7,
        hidden: 2,
        visibility: 4,
        geoInfos: [1],
        purpose: 7,
        usage: 4,
        format: 7,
        aggregation: 4,
        partitionOrigin: 4,
        timeFrame: 1,
        sortOn: 4,
        customSort: 1,
        forceServerFormatting: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DataItem;
